  <h4 style="text-align: center;">Print Assessment Appeals Board Minutes</h4>
  <h6 style="text-align: center;"><b>View the minutes of past Assessment Appeals Board meetings using the links below.</b></h6>
  <br />
  <div class="row">
    <div class="col-md-4 offset-md-3">
      <label for="selYear" style="padding-right: 10px; margin-left: 10px;" class="col-form-label prd-label">Select Year</label>
      <select title="Select Case Year to display all associated cases" id="selYear" [(ngModel)]='caseYear' >
        <option *ngFor="let yr of yearList">{{yr}}</option>
      </select>
      <button style="margin-left: 5px;"
              class="btn btn-success btn-sm" title="Click button to get list of minutes for selected year"
              (click)="getHearingList(caseYear)">Get List</button>
    </div>
    <div class="col-md-1 offset-md-1">
      <button class="btn btn-sm btn-link" title="Return to main menu" (click)="goHome()">Return to Menu</button>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6 offset-md-3">
      <div class="card" *ngIf='displayState.workingDiv'>
        <br />
        <div class="card-body">
          <div class="row" style="margin: 10px;" >
            <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
          </div>
        </div>
      </div>
    </div>
  </div>
<div class="row" style="margin: 10px;" *ngIf='displayState.gridDiv'>
  <br />
  <div class="col-md-6 offset-md-3">
    <div class="card">
      <div class="card-body" style="background-color:#e9ecef">
        <table class="table table-striped">
          <thead>
          <tr>
            <th *ngFor="let col of cols; let i = index">
              {{col.header}}
            </th>
            <th></th>
          </tr>
          </thead>
          <tbody>
            <tr *ngFor="let hearing of hearingList; let i = index">
              <td>{{ hearing.hearingDate | date:"MM/dd/yyyy"}}</td>
              <td>{{ hearing.hearingTime }}</td>
              <td><button class="btn btn-link" (click)="onSelect(hearing)"> View Minutes</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
